import React, { useEffect, useLayoutEffect } from 'react'
import './landing-page.styles.scss'

import { useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import logo_tall from '@/assets/logo_long_light_grad.png';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import FooterLinks from '@/components/layout-unauth/footer/footer-links.component';
import InfoLinks from '@/components/SHARED/info-links/info-links.component';

const LandingPage = () => {

  const currentUser = useSelector(state => state.userData.currentUser);
  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const navigate = useNavigate();

  useEffect(() => {
    // window.open('https://gamably.com', '_self');
    // navigate('/signin')
    // change var(--primary) to default color
    changeDocumentTitle();
    var r = document.querySelector(':root');
    r.style.setProperty('--primary', '#674fa7');
    r.style.setProperty('--primary-trans', '#674fa7a6');
  }, [])

  return (
    <div>
      <UnauthLayout>
        <div className='landing-page'>
          <img src={logo_tall} className='landing-icon' />
          <div className="g-space-20"></div>
          {
            (screenSize) &&
            (
              (currentUser && userProfile && userProfile.gamePath) ?
                <button className='g-button big' onClick={() => navigate(`/play/${userProfile.gamePath}`)}>Go To My Game</button>
                :
                (currentUser) ?
                  <button className='g-button big' onClick={() => navigate('/home')}>Your Games</button>
                  :
                  <div className={`buttons-div ${screenSize}`}>
                    <button className='g-button big' onClick={() => navigate('/signin')}>Sign In</button>
                    <button className='g-button big' onClick={() => navigate('/register')}>Create an Account</button>
                    <button className='g-button big' onClick={() => navigate('/join')}>Join a Game</button>
                    <button className='g-button bug' onClick={() => navigate('/preview')}>Give it a Try!</button>
                  </div>
            )
          }
          <div className="g-space-2"></div>
          {/* <p>Looking for Gamably Version 1? <a href="https://app-v1.gamably.com">Click Here!</a></p> */}
          <InfoLinks />
        </div>
      </UnauthLayout>
    </div>
  )
}

export default LandingPage;